import { ApplicationRef, Injectable } from '@angular/core';
import { HttpRequest, HttpInterceptor, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

/**
 * Forces an Angular change-detection tick after every HTTP request finalizes.
 *
 * With Angular 21 + zone.js 0.15, responses returning into a jQuery
 * DataTables `ajax` callback (and a few other library callsites) do not
 * always trigger a tick. Component state mutates (`showSpinnerTable = false`,
 * `news = apiData`, etc.) but the DOM stays frozen until the user clicks
 * anywhere. Ticking on `finalize` covers both success and error paths.
 */
@Injectable({ providedIn: 'root' })
export class CdTickInterceptorService implements HttpInterceptor {
    constructor(private appRef: ApplicationRef) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            finalize(() => this.appRef.tick())
        );
    }
}
